module.exports = __webpack_public_path__ + "img/sport_LALIGA.d19201af.png";